import axios from "axios";

import { actionCreators as uiActionCreators } from "./uiActions";
import { actionCreators as userActionCreators } from "./userActions";
import { actionCreators as widgetConfigActionCreators } from "./widgetConfigActions";

import { BASEURL } from "./../helpers/constants";

import { tsvParseRows } from "d3-dsv";

const ADD_DEVICE = "ADD_DEVICE";
const DELETE_DEVICE = "DELETE_DEVICE";

const TOGGLE_DEVICE_DATA_PANE = "TOGGLE_DEVICE_DATA_PANE";
//const TOGGLE_DEVICE_SETTINGS = "TOGGLE_DEVICE_SETTINGS";
const RECEIVE_DEVICES = "RECEIVE_DEVICES";

const ADD_SENSOR = "ADD_SENSOR";
const DELETE_SENSOR = "DELETE_SENSOR";

const SET_DEVICE_DATA_VAL = "SET_DEVICE_DATA_VAL";
const SET_DEVICE_SENSOR_DATA_VAL = "SET_DEVICE_SENSOR_DATA_VAL";

const RECEIVE_RAW_JSON = "RECEIVE_RAW_JSON";
const RESET_RAW_JSON = "RESET_RAW_JSON";
const RECEIVE_SENSOR_VALS = "RECEIVE_SENSOR_VALS";
const RECEIVE_DEVICE_RESULT_PROPS = "RECEIVE_DEVICE_RESULT_PROPS";
const RECEIVE_SENSOR_RESULT_PROPS = "RECEIVE_SENSOR_RESULT_PROPS";

const RECEIVE_SENSOR_HISTO_DATA = "RECEIVE_SENSOR_HISTO_DATA";

const SET_DEVICE_TEMPLATE_ID = "SET_DEVICE_TEMPLATE_ID";
//const SET_DEVICE_TEMPLATE_BLACKLIST = "SET_DEVICE_TEMPLATE_BLACKLIST";

axios.defaults.withCredentials = true;
/* API CALL THUNKS */

// const requestSensorHistoData = (device_uid, sensor_uid, begin, end, limit) => {
//   let qs = "";
//   qs += begin || end || limit ? "?" : "";
//   qs += begin ? `begin=${begin}` : "";
//   qs += end ? (begin ? `&end=${end}` : `end=${end}`) : "";
//   qs += limit ? (begin || end ? `&limit=${limit}` : `limit=${limit}`) : "";
//   return function(dispatch) {
//     axios
//       .get(`${BASEURL}/deviceapi/${device_uid}/sensor/${sensor_uid}/data${qs}`)
//       .then(function(response) {
//         let data = response.data;
//         let parsed = tsvParseRows(data, (data, i) => {
//           return {
//             date: data[0],
//             sensorid: data[1],
//             value: data[2]
//           };
//         }).reverse();
//         dispatch(receiveSensorHistoData(device_uid, sensor_uid, parsed));
//       })
//       .catch(function(error) {
//         // handle error
//         console.log(error);
//       });
//   };
// };

const requestAddDevice = name => {
  return function(dispatch) {
    axios
      .post(`${BASEURL}/deviceapi`)
      .then(function(response) {
        // handle success
        dispatch(addDevice(response.data.id, response.data.apikey));
        console.log(response);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
      });
  };
};

const requestDeleteDevice = device_uid => {
  return function(dispatch) {
    axios
      .delete(`${BASEURL}/deviceapi/${device_uid}`)
      .then(function(response) {
        // handle success

        dispatch(uiActionCreators.toggleDeviceSettings(device_uid));
        dispatch(deleteDevice(device_uid));
        dispatch(userActionCreators.persistWidgetConfig());
        console.log(response);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
      });
  };
};

const requestAddSensor = device_uid => {
  return function(dispatch) {
    axios
      .post(`${BASEURL}/deviceapi/${device_uid}/sensor`)
      .then(function(response) {
        // handle success
        console.log("requestAddSensor: SUCESS", response);

        dispatch(addSensor(device_uid, response.data.id));
        dispatch(
          uiActionCreators.switchToTab(device_uid, response.data.id.toString())
        );
      })
      .catch(function(error) {
        // handle error
        console.log("requestAddSensor: ERROR");
        console.log(error);
      });
  };
};

const requestDeleteSensor = (device_uid, sensor_uid) => {
  return function(dispatch) {
    axios
      .delete(
        `${BASEURL}/deviceapi/${device_uid}/sensor/${sensor_uid}`,
        {},
        { withCredentials: true }
      )
      .then(function(response) {
        // handle success
        console.log("requestDeleteSensor: SUCESS", response);
        //dispatch(uiActionCreators.toggleDeviceSettings(device_uid));

        // order matters here! Maybe use callbacks/async fns for the actions here.
        dispatch(uiActionCreators.switchToTab(device_uid, "last"));
        dispatch(deleteSensor(device_uid, sensor_uid)); 
        // Perist widget config, because the widget reducer also responds to this to update its sensor_slots array
        dispatch(userActionCreators.persistWidgetConfig());
      })
      .catch(function(error) {
        // handle error
        console.log("requestDeleteSensor: ERROR");
        console.log(error);
      });
  };
};

const requestResetJSONState = device_uid => {
  return function(dispatch) {
    dispatch(resetRawJSON(device_uid));
    axios
      .post(
        `${BASEURL}/deviceapi/${device_uid}/reset_combined_json`,
        {},
        { withCredentials: true }
      )
      .then(function(response) {})
      .catch(function(error) {
        console.log(error);
      });
  };
};

const requestResetDevice = device_uid => {
  return function(dispatch) {
    axios
      .post(`${BASEURL}/deviceapi/${device_uid}/reset_complete`)
      .then(function(response) {
        // handle success
        // TODO: fetch only this device, or alternatively get the empty device as res from server.
        dispatch(fetchDevices());
        dispatch(widgetConfigActionCreators.disconnectAllWidgetsFromDevice(device_uid));
      })
      .catch(function(error) {
        // handle error
        console.log(error);
      });
  };
};

// Reset local raw JSON state
const resetRawJSON = device_uid => {
  return {
    type: RESET_RAW_JSON,
    uid: device_uid
  };
};

const fetchDevices = cb => {
  return function(dispatch) {
    console.log("fetch devices called");
    axios
      .get(`${BASEURL}/deviceapi`)
      .then(function(response) {
        // handle success
        dispatch(receiveDevices(response.data));
        !!cb && cb();
      })
      .catch(function(error) {
        // handle error
        console.log(error);
      });
  };
};

const requestSetDeviceDataValue = (device_uid, key, value, method) => {
  return function(dispatch) {
    let payload = {
      [key]: {
        value,
        method
      }
    };
    axios
      .put(`${BASEURL}/deviceapi/${device_uid}`, payload)
      .then(function(response) {
        // handle success
        dispatch(setDeviceDataValue(device_uid, key, value, method));

        console.log("requestSetDeviceDataValue: SUCESS", response);
      })
      .catch(function(error) {
        // handle error
        console.log("requestSetDeviceDataValue: ERROR");
        console.log(error);
      });
  };
};

const requestSetDeviceSensorDataValue = (
  device_uid,
  sensor_uid,
  key,
  value,
  method
) => {
  return function(dispatch) {
    let payload = {
      [key]: {
        value,
        method
      }
    };
    axios
      .put(`${BASEURL}/deviceapi/${device_uid}/sensor/${sensor_uid}`, payload)
      .then(function(response) {
        // handle success
        dispatch(
          setDeviceSensorDataValue(device_uid, sensor_uid, key, value, method)
        );
      })
      .catch(function(error) {
        // handle error
        console.log(error);
      });
  };
};

const requestSetTemplateId = (device_uid, template_id) => {
  console.log(
    "requestSetTemplateId action creator called!",
    device_uid,
    template_id
  );
  return function(dispatch) {
    let payload = {
      template_id: template_id
    };
    axios
      .put(`${BASEURL}/deviceapi/${device_uid}`, payload)
      .then(function(response) {
        // handle success
        console.log("requestSetTemplateId: SUCESS", response);
        dispatch(setDeviceTemplateId(device_uid, template_id));
        // dispatch(fetchDevices());
      })
      .catch(function(error) {
        // handle error
        console.log("requestSetTemplateId: ERROR");
        console.log(error);
      });
  };
};

const requestResetTemplateId = device_uid => {
  console.log("requestResetTemplateId action creator called!", device_uid);
  return function(dispatch) {
    dispatch(requestSetTemplateId(device_uid, false));
  };
};

const requestSaveTemplate = device_uid => {
  return function(dispatch) {
    console.log("requestSaveTemplate action creator called!", device_uid);
    axios
      .post(`${BASEURL}/deviceapi/${device_uid}/save_template`)
      .then(function(response) {
        // handle success
        console.log("requestSaveTemplate response", response);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
      });
  };
};

const requestActivateTemplate = (device_uid, template_id) => {
  return function(dispatch) {
    console.log(
      "requestActivateTemplate action creator called!",
      device_uid,
      template_id
    );
    // API Aufruf /deviceapi/4170/apply_template/template_val
    // Abhanging von status code bzw. Erfolg des api aufrufs:
    // CB oder Promise zuruckgeben, oder direkt hier requestResetTemplateId thunk aufrufen.
    axios
      .post(`${BASEURL}/deviceapi/${device_uid}/apply_template/${template_id}`)
      .then(function(response) {
        // handle success
        console.log("requestActivateTemplate", response);
        //dispatch(requestSetTemplateId(device_uid, template_id));
        dispatch(fetchDevices());
      })
      .catch(function(error) {
        // handle error
        console.log(error);
      });
  };
};

/* API CALL RECEIVES */

// const receiveSensorHistoData = (deviceid, sensorid, data) => ({
//   type: RECEIVE_SENSOR_HISTO_DATA,
//   deviceid,
//   sensorid,
//   data
// });

const receiveResultPropertiesForDevice = (deviceid, result_properties) => ({
  type: RECEIVE_DEVICE_RESULT_PROPS,
  deviceid,
  result_properties
});

const receiveSensorResultPropertiesForDevice = (deviceid, sensorArray) => ({
  type: RECEIVE_SENSOR_RESULT_PROPS,
  deviceid,
  sensors: sensorArray // This array also contains the actual sensor values.
});

const receiveDevices = devices => ({
  type: RECEIVE_DEVICES,
  devices
});

const receiveRawJSONForDevice = (uid, JSONString) => {
  return {
    type: RECEIVE_RAW_JSON,
    uid,
    JSONString
  };
};

const receiveSensorValuesForDevice = (uid, sensor_values) => {
  return {
    type: RECEIVE_SENSOR_VALS,
    uid,
    sensor_values
  };
};

/* STANDARD ACTIONS */

const addDevice = (uid, apikey) => ({
  type: ADD_DEVICE,
  uid,
  apikey
});

const deleteDevice = uid => ({
  type: DELETE_DEVICE,
  uid
});

const deleteSensor = (device_uid, sensor_uid) => ({
  type: DELETE_SENSOR,
  device_uid,
  sensor_uid
});

const addSensor = (device_uid, sensor_uid) => ({
  type: ADD_SENSOR,
  device_uid,
  sensor_uid
});

const setDeviceDataValue = (uid, key, value, method) => {
  return {
    type: SET_DEVICE_DATA_VAL,
    uid,
    key,
    value,
    method
  };
};

const setDeviceSensorDataValue = (uid, sensorUid, key, value, method) => {
  return {
    type: SET_DEVICE_SENSOR_DATA_VAL,
    uid,
    sensorUid,
    key,
    value,
    method
  };
};

const setDeviceTemplateId = (uid, templateId) => {
  console.log("SET_DEVICE_TEMPLATE_ID action creator called!", uid, templateId);
  return {
    type: SET_DEVICE_TEMPLATE_ID,
    uid,
    template_id: templateId
  };
};

export const actionsTypes = {
  ADD_DEVICE,
  DELETE_DEVICE,
  RECEIVE_DEVICES,
  TOGGLE_DEVICE_DATA_PANE,
  ADD_SENSOR,
  DELETE_SENSOR,
  RECEIVE_RAW_JSON,
  RECEIVE_DEVICE_RESULT_PROPS,
  RECEIVE_SENSOR_RESULT_PROPS,
  RESET_RAW_JSON,
  RECEIVE_SENSOR_VALS,
  SET_DEVICE_DATA_VAL,
  SET_DEVICE_SENSOR_DATA_VAL,
  //RECEIVE_SENSOR_HISTO_DATA,
  SET_DEVICE_TEMPLATE_ID
};
export const actionCreators = {
  requestAddDevice,
  requestDeleteDevice,
  fetchDevices,
  addSensor,
  receiveRawJSONForDevice,
  receiveSensorValuesForDevice,
  receiveResultPropertiesForDevice,
  receiveSensorResultPropertiesForDevice,
  setDeviceDataValue,
  setDeviceSensorDataValue,
  requestAddSensor,
  requestDeleteSensor,
  requestSetDeviceDataValue,
  requestSetDeviceSensorDataValue,
  requestResetJSONState,
  //requestSensorHistoData,
  requestSetTemplateId,
  setDeviceTemplateId,
  requestResetTemplateId,
  requestSaveTemplate,
  requestActivateTemplate,
  requestResetDevice
};
